import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',

    '& .MuiOutlinedInput-root': {
      display: 'flex',
      flex: 1,
      color: theme.palette.text.primary,
      borderRadius: theme.spacing(2),
      backgroundColor: '#16171a',

      '& fieldset': {
        borderColor: 'transparent',
      },

      '& fieldset:hover': {
        borderColor: 'transparent',
      },

      '& fieldset legend': {
        width: theme.spacing(0),
      },
    },

    '& .MuiOutlinedInput-root.Mui-focused fieldset': {
      border: `${theme.spacing(0.125)} solid ${theme.palette.primary.main}`,
    },
  },

  error: {
    '& .MuiOutlinedInput-root fieldset': {
      border: `${theme.spacing(0.125)} solid ${theme.palette.error.main}`,
    },
  },
}));
